<template>
  <v-container fluid class="main-background text-center text-sm-left">
    <v-container class="text-center">
        <h4 class="section-title small-heading">Zaregistrujte se</h4>
        <h1 class="section-title large-heading">a získejte slevu</h1>
        <h3 class="section-title primary--text">10%</h3>
        <v-btn outlined color="white" @click="scrollTo('form')">To chci!</v-btn>
    </v-container>
  </v-container>
</template>

<script>
  export default {
    name: 'HeroBanner',

    data: () => ({
        options: {
            offset: 140,
        }
    }),
      methods: {
          scrollTo: function(target) {
              this.$vuetify.goTo(target, this.options)
          }
      }
  }
</script>

<style lang="scss">
  .main-background {
        background-image: linear-gradient(-90deg, rgba(0, 0, 0, 0.5) 100%), url(../assets/background/club-min.jpg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        padding: 120px 0;
          .divider {
              background: #f6f9f966;
              @media #{$pixel-less-phone} {
                  margin: auto;
              }
          }
        .section-title {
            font-weight: 800;
            color: #FFFFFF;
            &.small-heading {
                font-size: 20px;
                margin-bottom: 20px;
            }
            &.large-heading {
                font-size: 40px;
                line-height: 1.2;
            }
        }
      h3 {
          font-family: fruity-solid;
          margin: 20px 0;
          font-size: 40px;
      }
  }
</style>